export const SlidersIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1794_2476)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M76.577 67.1539H38.2116C39.5578 69.0385 40.2308 71.4616 40.2308 73.8847C40.2308 76.3078 39.4232 78.7308 38.2116 80.6155H76.577C80.3462 80.6155 83.3078 77.5193 83.3078 73.8847C83.3078 70.1155 80.3462 67.1539 76.577 67.1539ZM28.1155 64.4616C22.8655 64.4616 18.6924 68.6347 18.6924 73.8847C18.6924 79.0001 22.8655 83.3078 28.1155 83.3078C33.3655 83.3078 37.5385 79.0001 37.5385 73.8847C37.5385 68.6347 33.3655 64.4616 28.1155 64.4616ZM28.1155 77.9232C25.827 77.9232 24.077 76.0385 24.077 73.8847C24.077 71.5962 25.827 69.8462 28.1155 69.8462C30.4039 69.8462 32.1539 71.5962 32.1539 73.8847C32.1539 76.0385 30.4039 77.9232 28.1155 77.9232ZM25.4232 57.7308H63.7885C62.4424 55.8462 61.7693 53.4232 61.7693 51.0001C61.7693 48.577 62.577 46.1539 63.7885 44.2693H25.4232C21.6539 44.2693 18.6924 47.2308 18.6924 51.0001C18.6924 54.7693 21.6539 57.7308 25.4232 57.7308ZM73.8847 41.577C68.6347 41.577 64.4616 45.7501 64.4616 51.0001C64.4616 56.1155 68.6347 60.4232 73.8847 60.4232C79.1347 60.4232 83.3078 56.1155 83.3078 51.0001C83.3078 45.7501 79.1347 41.577 73.8847 41.577ZM73.8847 55.0385C71.5962 55.0385 69.8462 53.1539 69.8462 51.0001C69.8462 48.7116 71.5962 46.9616 73.8847 46.9616C76.1732 46.9616 77.9232 48.7116 77.9232 51.0001C77.9232 53.1539 76.1732 55.0385 73.8847 55.0385ZM76.577 34.8462C80.3462 34.8462 83.3078 31.7501 83.3078 28.1155C83.3078 24.3462 80.3462 21.3847 76.577 21.3847H38.2116C39.5578 23.2693 40.2308 25.6924 40.2308 28.1155C40.2308 30.5385 39.4232 32.9616 38.2116 34.8462H76.577ZM28.1155 37.5385C33.3655 37.5385 37.5385 33.2308 37.5385 28.1155C37.5385 22.8655 33.3655 18.6924 28.1155 18.6924C22.8655 18.6924 18.6924 22.8655 18.6924 28.1155C18.6924 33.2308 22.8655 37.5385 28.1155 37.5385ZM28.1155 24.077C30.4039 24.077 32.1539 25.827 32.1539 28.1155C32.1539 30.2693 30.4039 32.1539 28.1155 32.1539C25.827 32.1539 24.077 30.2693 24.077 28.1155C24.077 25.827 25.827 24.077 28.1155 24.077Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1794_2476)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1794_2476"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1794_2476"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1794_2476"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1794_2476"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
